/* eslint-disable max-len */
import * as React from "react";

interface SVGRProps {
    title?: string;
    titleId?: string;
}

export const HealthAndWellnessIcon = ({ title, titleId, ...props }: React.SVGProps<SVGSVGElement> & SVGRProps) => (
    <svg viewBox="0 0 20 20" aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <path d="M15.94,6a1.1,1.1,0,0,0-.32-.78,1.14,1.14,0,0,0-.78-.32H11.53V1.6a1.14,1.14,0,0,0-.32-.78A1.14,1.14,0,0,0,10.43.5H6a1.14,1.14,0,0,0-.78.32,1.14,1.14,0,0,0-.32.78V4.91H1.6a1.14,1.14,0,0,0-.78.32A1.14,1.14,0,0,0,.5,6v4.42a1.14,1.14,0,0,0,.32.78,1.14,1.14,0,0,0,.78.32H4.91v3.31a1.14,1.14,0,0,0,.32.78,1.1,1.1,0,0,0,.78.32h4.42a1.1,1.1,0,0,0,.78-.32,1.14,1.14,0,0,0,.32-.78V11.53h3.31a1.14,1.14,0,0,0,.78-.32,1.1,1.1,0,0,0,.32-.78Z" fill="#d8f0e9" stroke="#666" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);
